import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Collapse, Nav, Navbar, NavbarToggler, NavItem, NavLink} from "reactstrap";
import {NavLink as NavLinkRRD, useHistory, useLocation} from "react-router-dom";
import actions from "actions/index.js";
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {Line} from "@pages/reusable-components/styled-components";
import usePrevious from "../hooks/useprevious";
import AdminNavbar from "./Navbars/AdminNavbar";
import queryString from "query-string";

export default function TopMenu({routes,menu,isSmall = false,show}) {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { activeMenu, menuName, roles, permissions, routeCan, authUserTeam, activeSubmenusList } = useSelector(
        state => state.getState,
        shallowEqual
    );

    const [isOpen, setOpen] = useState(false);
    const prevTab = usePrevious(activeMenu)
    const hasPermission = (permissions, _permissions) => {
        return _permissions.some(permission => {
            return permissions.includes(permission)
        });
    }

    const findId = (url) => {
       return url.split('/')
    };

    useEffect(()=>{
        if (prevTab === 'payments') {
           let id = findId(location.pathname)[3]
            if (id) {
                history.push({
                    pathname: '/admin/deals/' + id + '/edit',
                })
            }
        }
        if (prevTab === 'tracking') {
            let id = findId(location.pathname)[3]
            if (id) {
                history.push({
                    pathname: '/admin/deals/' + id + '/edit',
                })
            }

        }
        if ((prevTab === 'info' || activeMenu === 'info') && location.pathname === '/admin/send-email') {
            let params = queryString.parse(location.search)
            if (params?.id) {
                history.push({
                    pathname: '/admin/deals/' + params.id + '/edit',
                })
            }
        }
        if (menuName === 'Customers' && (prevTab === 'tasks' || prevTab === 'notes')) {
            let id = findId(location.pathname)[3]
            if (id) {
                if (activeMenu === 'tasks' || activeMenu === 'notes') {
                    goSub(activeMenu,id)
                } else {
                    history.push({
                        pathname: '/admin/customer/' + id + '/edit',
                    })
                }
            }
        }
    },[activeMenu])

    const goSub = (subject,id) => {
        switch (subject) {
            case 'tasks':
                history.push({
                    pathname: '/admin/customer/' + id + '/tasks',

                });
                break;

            case 'notes':
                history.push({
                    pathname: '/admin/customer/' + id + '/notes',

                });
                break;

            default:
                break;
        }
    }

    useEffect(()=>{
        if (!menuName || menu?.name === menuName) return
            dispatch(actions.setMenusList([]))
            dispatch(actions.setMenuName(null))
            dispatch(actions.setActiveMenu(null))
    },[menuName,menu?.name,dispatch])

   const getNavbarTheme = () => {
        return location.pathname.indexOf(
            "admin/alternative-dashboard"
        ) === -1
            ? "dark"
            : "light";
    };
   const getBrandText = () => {
        for (let i = 0; i < routes.length; i++) {
            if (
                location.pathname.indexOf(
                    routes[i].layout + routes[i].path
                ) !== -1
            ) {
                return routes[i].name;
            }
        }
        return "Brand";
    };
    const hasCan = (routeCan, can) => {
        return routeCan[can]
    }
    // check has role
    const hasRole = (roles, _roles) => {
        return _roles.some(role => {
            return roles.includes(role)
        });
    }
    const handleTabClick = useCallback((val) => {
        dispatch(actions.setActiveMenu(val));
    }, [dispatch]);
    const createSubmenus = useMemo(() => {
        return activeSubmenusList.map((prop) => (
            <NavItem className='d-flex flex-column cursor-pointer' key={`${prop.key}${prop.value}`}>
                <NavLink active onClick={() => handleTabClick(prop.value)} className='header-nav-text-style'>
                    <span style={{ color: 'white', fontSize: isSmall ? '12px' : '16px' }}>{prop.key}</span>
                </NavLink>
                {activeMenu === prop.value && <Line />}
            </NavItem>
        ));
    }, [activeSubmenusList, activeMenu, isSmall,handleTabClick]);

    const createLinks = routes => {
        return routes.map((prop) => {
            if (prop.hide) {
                if (hasRole(roles, prop.hide)) {
                    return null
                }
            }
            if (permissions && routeCan && roles) {
                if (prop.permission === 'hidden') {
                    return null
                }
                if (prop.permission) {
                    if (!hasPermission(permissions, prop.permission)) {
                        return null
                    }
                }



                if (prop.role) {
                    if (!hasRole(roles, prop.role)) {
                        return null
                    }
                }

                if (prop.can) {
                    if (!hasCan(routeCan, prop.can)) {
                        return null
                    }
                }

                if (prop.authUserTeam === true) {
                    if (!authUserTeam) {
                        return null
                    }
                } else if (prop.authUserTeam === false) {
                    if (authUserTeam) {
                        return null
                    }
                }

                if (prop.name !== 'NavHidden') {
                    if (prop.redirect) {
                        return null;
                    }
                    return (
                        <NavItem className={'d-flex flex-column cursor-pointer'} key={`${prop.layout}${prop.path}`}>
                            <NavLink  active={true}  to={prop.layout + prop.path}
                                      tag={NavLinkRRD}  className={'header-nav-text-style'}><span className={'submenus'}>{prop.name}</span></NavLink>
                            {location.pathname === `${prop.layout}${prop.path}` && <Line/> }
                        </NavItem>
                    );
                }
            }
        });
    };
    const toggle = () => (setOpen(!isOpen))
    return (
        <>
            {isSmall ?
                <>
                    {
                        activeSubmenusList.length ?
                        <div style={{backgroundColor: '#ec6409'}}>
                            <Navbar color="#ec6409" expand="md">
                                <Collapse isOpen={true} navbar className={'justify-content-between'}>
                                    <Nav>
                                        {createSubmenus}
                                    </Nav>
                                </Collapse>
                            </Navbar>
                        </div> : <></>
                    }
                </>
                :
                show ?
                        <div style={{backgroundColor: '#ec6409'}}>
                            <Navbar className={'pb-0 pt-0'} color="#ec6409" expand="md">
                                <NavbarToggler onClick={toggle}/>
                                <Collapse isOpen={true} navbar className={'justify-content-between'}>
                                    {activeSubmenusList.length ?
                                        <Nav>
                                            {createSubmenus}
                                        </Nav>
                                        :
                                        <Nav className={'justify-content-around cursor-pointer'}>
                                            {createLinks(routes)}
                                        </Nav>
                                    }
                                    <div>
                                        <AdminNavbar
                                            getData={false}
                                            theme={getNavbarTheme}
                                            sidenavOpen={true}
                                        />
                                    </div>
                                </Collapse>
                            </Navbar>
                        </div> : <></>
            }
        </>
    )
}